import actions from './actions'
import getters from './getters'
import EmployerCategoryFactory from '@/factory/employer_category'
import mutations from './mutations'

export default {
  state: {
    employerCategory: new EmployerCategoryFactory().create(),
    employerCategories: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
